import React from "react";
import useStyles from "../styles/useStyles";

const StaleBanner: React.FC<{ canManage: boolean }> = ({ canManage }) => {
  const styles = useStyles();
  return (
    <div className={styles.banner} role="status">
      {`This project has changed since the review ran. Refresh the review to see current results.${
        canManage ? " Refreshing clears your checkmarks." : ""
      }`}
    </div>
  );
};

export default StaleBanner;
